// extracted by mini-css-extract-plugin
export default {"root":"SectionContainer_root__A1BjA","sectionContent":"SectionContainer_sectionContent__vqzb1","backgroundImageWrapper":"SectionContainer_backgroundImageWrapper__RlvT9"};